<template>
  <section class="listing">
    <div class="header">
      <div class="title">Borderôs</div>
      <div class="legend legend-1"><div></div><div>Online</div></div>
      <div class="legend legend-2"><div></div><div>Bilheteria</div></div>
    </div>
    <form @submit.prevent class="form form-search" style="padding: 0">
      <date-picker v-model="period" @change="getData" range placeholder="Selecione um período" format="DD/MM/YYYY"></date-picker>
      <div class="search-input">
        <input v-model="search" type="text" placeholder="Pesquisar..." />
        <i class="fas fa-search show-search"></i>
      </div>
    </form>
    <transition name="show" mode="out-in">
      <i v-if="loading" class="fas fa-spinner loading-big"></i>
      <div v-if="!loading" style="margin-top: 10px">
        <div v-for="(show, index) in filtered" :key="show.id" class="list">
          <div v-if="index > 0 ? getDay(show.date) !== getDay(shows[index - 1].date) : true" class="calendar">
            <span>{{ getDay(show.date) }}</span>
            <span>{{ getMonthText(show.date) }}</span>
          </div>
          <div v-if="index > 0 ? getDay(show.date) === getDay(shows[index - 1].date) : false" style="width: 50px"></div>
          <div class="time-text">
            <span>{{ getHours(show.date) }}</span>
            <span>{{ getMinutes(show.date) }}</span>
          </div>
          <div class="data">
            <div class="main-data">{{ show.name }} </div> <div> {{`${show.businessName} (${show.businessCity})` }}</div>
            <div class="detail-data">
              <div v-if="show.withoutStage" class="show-progress">
                <div v-if="Number(show.tiketera) > 0" class="show-progress-bar bar-1" :style="`width: ${getPercent(show.tiketera, show.amountTickets)}%`"></div>
                <div v-if="Number(show.ticket) > 0" class="show-progress-bar bar-2" :style="`width: ${getPercent(show.ticket, show.amountTickets)}%`"></div>
                <div class="show-progress-bar bar-3" :style="`width: ${getPercent(Number(show.amountTickets) - Number(show.ticket) + Number(show.tiketera), show.amountTickets)}%`"></div>
              </div>
              <div v-else class="show-progress">
                <div v-if="Number(show.tiketera) > 0" class="show-progress-bar bar-1" :style="`width: ${getPercent(show.tiketera, show.capacity)}%`"></div>
                <div v-if="Number(show.ticket) > 0" class="show-progress-bar bar-2" :style="`width: ${getPercent(show.ticket, show.capacity)}%`"></div>
                <div class="show-progress-bar bar-3" :style="`width: ${getPercent(Number(show.capacity) - Number(show.ticket) + Number(show.tiketera), show.capacity)}%`"></div>
              </div>
              <div v-if="show.withoutStage" style="text-align: center">
                <span style="color: #560070">{{ show.tiketera }}</span>
                ({{ getPercent(show.tiketera, show.amountTickets) }}%)
                /
                <span style="color: #0071b3">{{ show.ticket }}</span>
                ({{ getPercent(show.ticket, show.amountTickets) }}%)
              </div>
              <div v-else style="text-align: center">
                <span style="color: #560070">{{ show.tiketera }}</span>
                ({{ getPercent(show.tiketera, show.capacity) }}%)
                /
                <span style="color: #0071b3">{{ show.ticket }}</span>
                ({{ getPercent(show.ticket, show.capacity) }}%)
              </div>
            </div>
          </div>
          <div class="actions">
            <button @click="$router.push(`/bordero/${show.id}`)" class="button-action">
              <i class="far fa-eye"></i><span>VISUALIZAR</span>
            </button>
          </div>
        </div>
      </div>
    </transition>
  </section>
</template>

<script>
import { mapState } from 'vuex'
import logger from '../../logger'
import { getAllForBusiness, getAllForProducer } from '../api/bordero'

export default {
  name: 'borderos',
  data () {
    return {
      loading: true,
      shows: [],
      search: '',
      period: []
    }
  },
  computed: {
    ...mapState(['user']),
    filtered () {
      return this.shows.filter(x => Object.keys(x).some(key => String(x[key]).toUpperCase().includes(this.search.toUpperCase())))
    }
  },
  async mounted () {
    try {
      const iniDate = new Date()
      iniDate.setDate(iniDate.getDate() - 15)
      const endDate = new Date()
      endDate.setDate(endDate.getDate() + 15)
      this.period = [iniDate, endDate]
      this.getData()
    } catch (error) {
      logger.error(error, this)
    }
  },
  methods: {
    async getData () {
      if (!this.period[0] || !this.period[1]) return false
      this.loading = true
      try {
        // Producer
        if (this.user.role === 'producer') {
          this.shows = await getAllForProducer(
            this.period[0].toISOString().split('T')[0],
            this.period[1].toISOString().split('T')[0]
          )
        // Business
        } else {
          this.shows = await getAllForBusiness(
            this.period[0].toISOString().split('T')[0],
            this.period[1].toISOString().split('T')[0]
          )
        }
      } catch (error) {
        logger.error(error, this)
      }
      this.loading = false
    },
    getPercent (value, total) {
      return Math.round(Number(value) / Number(total) * 100)
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../_asset/scss/_variables";

.detail-data {
  display: flex;
  align-items: center;
  margin: 3px 10px 0 0 ;
  span {
    font-weight: 500;
  }
}

.show-progress {
  flex-grow: 1;
  display: flex;
  margin-right: 5px;
  .show-progress-bar {
    height: 12px;
    margin: 0 1px;
    border-radius: 2px;
    transition: width 2s;
    min-width: 4px;
    &.bar-1 { background: linear-gradient(to bottom right, $primary-color, $secondary-color); }
    &.bar-2 { background: linear-gradient(to bottom right, #0071b3, #0098b3); }
    &.bar-3 { background: #ccc; }
  }
}

.calendar {
  width: 40px;
  height: 40px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  color: #fff;
  background-image: linear-gradient(to bottom right, $primary-color, $secondary-color);
  border-radius: 5px;
  margin-right: 10px;
  font-weight: 500;
  span:nth-child(1) {
    font-size: 1.2em;
  }
  span:nth-child(2) {
    font-size: 0.7em;
  }
}

.time-text {
  font-size: 2.2em;
  font-weight: 400;
  margin-right: 10px;
  color: #555;
  display: flex;
  span:nth-child(2) {
    font-size: 0.5em;
    line-height: 2em;
  }
}

.form-search {
  display: flex;
  flex-direction: row;
  padding: 0;

  .search-input {
    flex: 1;
    margin: 5px;
    position: relative;
    input {
      margin-top: 0;
      width: 100%;
    }
    i {
      position: absolute;
      top: 6px;
      right: 6px;
      color: #666;
      font-size: 1.5em;
    }
  }
}

.button-action:hover {
  i {
    animation-name: ticket-image !important;
    animation-duration: 0.5s !important;
    animation-iteration-count: 1 !important;
  }
}

.legend {
  display: flex;
  align-items: center;
  margin: 0 10px;
  font-size: 0.85em;
  color: #777;
  text-transform: uppercase;
  div:nth-child(1) {
    width: 20px;
    height: 12px;
    border-radius: 2px;
    margin-right: 5px;
  }
  &.legend-1 > div:nth-child(1) { background: linear-gradient(to bottom right, $primary-color, $secondary-color); }
  &.legend-2 > div:nth-child(1) { background: linear-gradient(to bottom right, #0071b3, #0098b3); }
}
</style>
